"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toKnownErr = toKnownErr;
function toKnownErr(e) {
    return e;
}
//# sourceMappingURL=updateActorAccess.js.map